export const ResolveUrl = (path: string | URL): URL =>
  new URL(path, globalThis.location?.href)
